
export const validatePassword = (password: string): { valid: boolean; message: string } => {
  const minLength = 8;
  const hasNumber = /[0-9]/.test(password);
  const hasSpecialChar = /[!@#$%^&*(),.?":{}|<>]/.test(password);
  const hasUpperCase = /[A-Z]/.test(password);

  if (password.length < minLength) {
    return { 
      valid: false, 
      message: "Password must be at least 8 characters long" 
    };
  }

  if (!hasNumber) {
    return { 
      valid: false, 
      message: "Password must contain at least one number" 
    };
  }

  if (!hasSpecialChar) {
    return { 
      valid: false, 
      message: "Password must contain at least one special character" 
    };
  }

  if (!hasUpperCase) {
    return { 
      valid: false, 
      message: "Password must contain at least one uppercase letter" 
    };
  }

  return { valid: true, message: "" };
};
